const p={path:"/api/v1/apps/:app_id",method:"GET"};export{p as AppConfig};
